/**
 * Yearly-fee discount on a family registration (dollar amount off the site fee).
 * Apply/remove is separate from Mark Paid — discounted families stay unpaid
 * until staff records payment. Collected dollars use the remaining amount due.
 */

export function familyRegistrationDiscountCents(reg: {
  feeDiscountApplied?: boolean;
  feeDiscountCents?: number;
}): number {
  if (reg.feeDiscountApplied !== true) return 0;
  const cents = Math.round(Number(reg.feeDiscountCents));
  return Number.isFinite(cents) && cents > 0 ? cents : 0;
}

export function isFamilyRegistrationFeeDiscounted(reg: {
  feeDiscountApplied?: boolean;
  feeDiscountCents?: number;
}): boolean {
  return familyRegistrationDiscountCents(reg) > 0;
}

/** Clamp a requested discount to a whole-cent amount between 1 and the current fee. */
export function normalizeFamilyRegistrationDiscountCents(
  discountCents: number,
  feeCents: number
): number | null {
  const fee = Math.max(0, Math.round(Number.isFinite(feeCents) ? feeCents : 0));
  const cents = Math.round(Number(discountCents));
  if (!Number.isFinite(cents) || cents <= 0 || fee <= 0 || cents > fee) {
    return null;
  }
  return cents;
}

/** Amount still due after a stored discount (never below $0). */
export function familyRegistrationAmountDueCents(
  feeCents: number,
  discountCents: number
): number {
  const fee = Math.max(0, Math.round(Number.isFinite(feeCents) ? feeCents : 0));
  const discount = Math.max(0, Math.round(Number.isFinite(discountCents) ? discountCents : 0));
  return Math.max(0, fee - discount);
}

/** Dollars collected for one family when marked paid (remaining due). */
export function familyRegistrationCollectedCents(
  paid: boolean,
  feeCents: number,
  discountCents: number
): number {
  if (!paid) return 0;
  return familyRegistrationAmountDueCents(feeCents, discountCents);
}
